// CustomLayout.tsx
import { Layout, type LayoutProps } from 'react-admin';
import { Box } from '@mui/material';
import CustomMenu from './CustomMenu';
import CustomAppBar from './CustomAppBar';
import CustomSidebar from './CustomSidebar';
import { isDemoSession, isSupportSession } from './apiClient';
import DemoBanner from './demo/DemoBanner';
import TalkToNick from './demo/TalkToNick';
import SupportBanner from './platform/SupportBanner';

const CustomLayout = ({ children, ...props }: LayoutProps) => {
  const demo = isDemoSession();
  const support = isSupportSession();
  return (
    <Layout
      {...props}
      menu={CustomMenu}
      appBar={CustomAppBar}
      sidebar={CustomSidebar}
      appBarAlwaysOn
      sx={{
        // Below desktop the page fits the screen. react-admin sizes it to its widest row,
        // so one long tab row or table pushed every page, Save bar included, past a phone's edge.
        minWidth: { xs: 0, md: 'fit-content' },
        '& .RaLayout-content, & .RaShow-card, & .RaList-main': { minWidth: { xs: 0, md: 'auto' } },
        // Clears the 64px bar (56px on phones) rather than react-admin's 48px one.
        '& .RaLayout-appFrame': { mt: { xs: 7, sm: 8 } }
      }}
    >
      {demo || support ? (
        // Same gutter as the pages below it, so the banner lines up with their content.
        <Box sx={{ px: { xs: 2, sm: 3 }, pt: { xs: 1, sm: 2 } }}>
          {demo ? <DemoBanner /> : <SupportBanner />}
        </Box>
      ) : null}
      {children}
      {demo ? <TalkToNick /> : null}
    </Layout>
  );
};

export default CustomLayout;
